export default __webpack_public_path__ + "navigation-examples-route-lines-styling-1200-0eb0a130eb47d539c0749800e298c57c.webp";